// Safe localStorage wrapper (private mode / blocked storage throws).
export const store = {
	get(k) {
		try { return localStorage.getItem(k); } catch { return null; }
	},
	set(k, v) {
		try { localStorage.setItem(k, v); } catch {}
	},
};
